import { createFileRoute } from '@tanstack/react-router'
import { useMemo } from 'react'

import { HomeContentContainer } from '@/components'
import { UserForm } from '@/components/pages/Admin/UserManagement/Form/UserForm'
import { useGetUserById } from '@/modules/user/services/user'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/(dashboard)/admin/user/$id/edit')({
  component: UserEditPage,
})

function UserEditPage() {
  const t = useTranslations('admin.user_management.edit')
  const { id } = Route.useParams()
  const { data: user } = useGetUserById(id)

  const userData = useMemo(() => {
    console.log(user)
    return {
      username: user?.username,
      firstname: user?.firstname,
      lastname: user?.lastname,
      role: user?.role?.id,
      status: user?.status.toLowerCase(),
    }
  }, [user])

  return (
    <HomeContentContainer title={t('title')}>
      <UserForm action="edit" data={userData as any} id={id} />
    </HomeContentContainer>
  )
}

